import type { FeatureModule } from '@store/features/types';

/**
 * Patient Requirements feature module (GDN-3224).
 *
 * API-only: the catalog's server state lives in RTK Query, so there is no
 * slice, no persistence and no cross-tab sync. RTK Query middleware is already
 * registered globally on baseApi — do not add it here.
 */
export const patientRequirementsFeature: FeatureModule = {
  id: 'patient-requirements',
  name: 'Patient Requirements',

  dependencies: [],

  reducers: {},

  middleware: [],

  persistence: {
    enabled: false,
  },

  sync: {
    enabled: false,
  },
};
